<template>
  <div>
    <h2>水塘管理</h2>
    <div>
      <input v-model="searchCustomerId" placeholder="输入客户ID" />
      <button @click="searchPonds">查询水塘</button>
    </div>
    <table>
      <tr v-for="pond in ponds" :key="pond.id">
        <td>{{ pond.name }}</td>
        <td>
          <button @click="editPond(pond.id)">修改</button>
          <button @click="deletePond(pond.id)">删除</button>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { fetchPonds, createPond, updatePond, deletePond } from '@/api/pond';

export default {
  data() {
    return {
      ponds: [],
      searchCustomerId: '', // 用于输入的客户ID
      pageParams: {
        current: 1,
        pageSize: 10,
      }
    };
  },
  methods: {
    // 点击查询按钮时调用此方法
    async searchPonds() {
      if (!this.searchCustomerId.trim()) {
        alert("请输入客户ID");
        return;
      }

      try {
        const response = await fetchPonds({
          "customerId": parseInt(this.searchCustomerId, 10),
          "current": this.pageParams.current,
          "pageSize": this.pageParams.pageSize,
        });
        if (response.data && response.data.records) {
          this.ponds = response.data.records;
        } else {
          alert("未查询到水塘数据");
        }
      } catch (error) {
        console.error("加载水塘数据失败:", error);
        alert("加载水塘数据失败，请检查客户ID是否有效");
      }
    },
    async createPond() {
      await createPond({name: '新水塘', customerId: this.searchCustomerId});
      this.searchPonds();
    },
    async editPond(pondId) {
      await updatePond(pondId, {name: '更新后的水塘名'});
      this.searchPonds();
    },
    async deletePond(pondId) {
      await deletePond(pondId);
      this.searchPonds();
    },
  }
};
</script>
